export default __webpack_public_path__ + "static/media/V344_V346_C_BD.057f6585.pdf";